var exports = {
  "kL": "GroupDMAvatar.module__container___OHZEcF",
  "kg": "GroupDMAvatar.module__statusDot___OHZEcF",
  "O0": "GroupDMAvatar.module__iconImageContainer___OHZEcF",
  "c4": "GroupDMAvatar.module__defaultIconContainer___OHZEcF",
  "DE": "GroupDMAvatar.module__defaultIcon___OHZEcF",
  "EQ": "GroupDMAvatar.module__multiAvatarContainer___OHZEcF",
};

module.exports = exports;
